import * as React from 'react';


import PlacesInput, { IPlacesInputProps, TPlace, TPlacesOptions } from './PlacesInput';

type TPlacesInputProps = Pick<IPlacesInputProps, 'debounceWait' | 'emptyOptionsMessage' | 'onChange' | 'placeholder'>;

interface IStateInputProps extends TPlacesInputProps {
  className?: string;
}

const OPTIONS: TPlacesOptions = {
  types: ['(regions)'],
  componentRestrictions: {
    country: 'us',
  },
};

const formatter = (prediction: google.maps.places.AutocompletePrediction): TPlace => {
  if (prediction.types[0] === 'administrative_area_level_1') {
    return {
      label: prediction.description,
      value: prediction.place_id,
    };
  }
};

export const StateInput: React.FunctionComponent<IStateInputProps> = (props) => {
  return (
    <PlacesInput
      className={props.className}
      placeholder={props.placeholder}
      onChange={props.onChange}
      emptyOptionsMessage={props.emptyOptionsMessage}
      options={OPTIONS}
      formatPrediction={formatter}
      debounceWait={props.debounceWait}
    />
  );
};

StateInput.defaultProps = {
  placeholder: 'Enter a state',
  emptyOptionsMessage: 'Please input more characters',
};

